import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { getExpediteShippingStateById } from "@TKCCP/Store/Data/ExpediteShipping/ExpediteShippingSelector";
import ApplicationStateTKCCP from "@TKCCP/Store/TKCCPState";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationStateTKCCP) => {
    const cartState = getCartState(state, state.pages.orderConfirmation.cartId).value;
    const getExpediteShippingState = getExpediteShippingStateById(state, cartState?.id!);
    return {
        expediteShippingState: getExpediteShippingState,
        settings: getSettingsCollection(state),
    };
};
export interface ExpediteMsg {
    expediteMsg?: InjectableCss;
}
export const expediteMsgStyles: ExpediteMsg = {
    expediteMsg: {
        css: css`
            text-align: right;
            padding: 0;
            @media screen and (max-width: 767px) {
                text-align: left;
            }
            @media print {
                padding: 0;
                text-align: left;
            }
        `,
    },
};
type Props = ReturnType<typeof mapStateToProps>;

const ConfirmationExpediteShipping: FC<Props> = ({ expediteShippingState,settings }) => {
    const enableExpediteShipping= settings?.expediteShippingSetting;
    // eslint-disable-next-line no-console
    console.log(enableExpediteShipping);
    return (
        <>
            <StyledWrapper {...expediteMsgStyles.expediteMsg}>
                {enableExpediteShipping && expediteShippingState.value?.isExpediteShipping
                    ? siteMessage("OrderDetailsIfExpediteShipping")
                    : siteMessage("OrderDetailsIfNotExpediteShipping")}
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ConfirmationExpediteShipping),

    definition: {
        group: "Order Confirmation",
    },
};

export default widgetModule;
